import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@predoc/cow';

const SkeletonRow = () => {
  return (
    <TableRow className="animate-pulse">
      <TableCell>
        <div className="flex items-center gap-2">
          <div className="h-4 w-32 rounded bg-gray-200"></div>
          <div className="h-5 w-16 rounded-full bg-gray-100"></div>
        </div>
      </TableCell>
      <TableCell>
        <div className="h-4 w-40 rounded bg-gray-200"></div>
      </TableCell>
      <TableCell>
        <div className="h-4 w-16 rounded bg-gray-200"></div>
      </TableCell>
      <TableCell>
        <div className="h-6 w-20 rounded-full bg-gray-200"></div>
      </TableCell>
      <TableCell>
        <div className="h-8 w-8 rounded bg-gray-200"></div>
      </TableCell>
    </TableRow>
  );
};

export const UsersTableSkeleton = ({ pageSize }: { pageSize: number }) => {
  return (
    <div className="container mx-auto p-10">
      <div className="rounded-md border shadow-sm">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>User</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Invite Status</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: pageSize }).map((_, index) => (
              <SkeletonRow key={index} />
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
